import React from 'react'
import { Route, Routes } from 'react-router-dom'
import LandingPage from './components/LandingPage'
import SuccessInstallationPage from './components/SuccessInstallationPage'
import { infoRoutes } from './setup/config'

const InfoApp: React.FC = () => {
  return (
    <Routes>
      <Route
        path={infoRoutes.landingPage}
        element={<LandingPage />}
      />
      <Route
        path={infoRoutes.installationPage}
        element={<SuccessInstallationPage />}
      />
    </Routes>
  )
}

export default InfoApp
